import { IDeveloperField } from 'dromo-uploader-react'
import { OptionsMap } from '../typings'
import { createSelectField } from './createSelectField'
import { taxOptions } from '../constants'
import { CustomFieldData } from '@user/store/customFields/hooks/useSelectCustomFieldData'
import { createCustomFields } from './createCustomFields'

export const opportunityFieldSettings = (
  options: OptionsMap,
  dateFormat: string,
  customFieldsData: CustomFieldData,
): IDeveloperField[] => {
  const { services, salesFunnelOpportunityStages, frequencies, users } = options

  return [
    {
      key: 'locationCode',
      label: 'Location Code',
      validators: [
        {
          validate: 'regex_match',
          regex: '^\\d{6,10}$',
          errorMessage:
            'Location Code must contain only digits and be between 6 and 10 characters.',
        },
      ],
    },
    {
      key: 'opportunityName',
      label: 'Opportunity Name',
      validators: [
        {
          validate: 'required',
        },
        {
          validate: 'length',
          min: 1,
          max: 100,
          errorMessage: 'Opportunity Name cannot exceed 100 characters',
        },
      ],
    },
    {
      key: 'expectedClosingDate',
      label: 'Expected Closing Date',
      type: [
        'date',
        {
          displayFormat: `${dateFormat}`,
        },
      ],
      validators: [
        {
          validate: 'required',
        },
      ],
    },

    {
      key: 'quantity',
      label: 'Quantity',
      type: ['number', 'integer'],
      validators: [{ validate: 'required' }],
    },

    {
      key: 'initialPrice',
      label: 'Initial Price',
      type: ['number', 'decimal_2'],
      validators: [{ validate: 'required' }],
    },

    // select fields
    createSelectField(
      'assigneeId',
      'Owner',
      users,
      [{ validate: 'required' }],
      false,
      '',
    ),

    createSelectField('serviceName', 'Service Name', services, [
      { validate: 'required' },
    ]),

    createSelectField('frequencyName', 'Frequency', frequencies, [
      { validate: 'required' },
    ]),

    createSelectField('taxable', 'Taxable (Y/N)', taxOptions, [
      { validate: 'required' },
    ]),

    createSelectField(
      'opportunityFunnelStageName',
      'Opportunity Stage',
      salesFunnelOpportunityStages,
      [{ validate: 'required' }],
    ),

    // hidden fields
    { key: 'serviceId', label: 'Service Id', hidden: true },
    {
      key: 'opportunityFunnelStageId',
      label: 'Opportunity Funnel Stage Id',
      hidden: true,
    },

    { key: 'frequencyId', label: 'Frequency Id', hidden: true },
    { key: 'annualOccurrences', label: 'Annual Occurrences', hidden: true },
    { key: 'assigneeName', label: 'assignee Name', hidden: true },

    ...createCustomFields(customFieldsData, dateFormat),
  ]
}
